import { SxProps, useTheme } from '@mui/material';

import { useScreenOrientation } from '@hooks/useScreenOrientation';

import { DRAWER } from '../config';

export const useStyles = () => {
  const orientation = useScreenOrientation();
  const theme = useTheme();

  const getDrawerStyles = (size: number): SxProps => {
    return {
      borderTop: orientation === 'landscape' ? 'none' : `1px solid ${theme.palette.grey[700]}`,
      boxSizing: 'content-box',
      height: orientation === 'landscape' ? '100%' : `${size}px`,
      minWidth: orientation === 'landscape' ? `${size}px` : '100%',
      maxWidth: orientation === 'landscape' ? `${size}px` : '100%',
    };
  };

  const getResizerStyles = (): SxProps => {
    return orientation === 'landscape'
      ? {
        top: 0,
        right: 0,
        bottom: 0,
        width: DRAWER.resizerWidth,
        cursor: 'col-resize',
      }
      : {
        left: 0,
        right: 0,
        bottom: 0,
        height: DRAWER.resizerWidth,
        cursor: 'row-resize',
      };
  };

  const getResizerIconStyles = (): SxProps => {
    return orientation === 'landscape'
      ? {
        top: '50%',
        transform: 'translateY(-50%) rotate(90deg)',
        left: 0,
      }
      : {
        left: '50%',
        bottom: 0,
      };
  };

  return { getResizerStyles, getDrawerStyles, getResizerIconStyles };
};
